module.exports = __webpack_public_path__ + "img/icon_montedecaleeDJ.232d269d.svg";